<script>
export default {
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		relative: {
			type: Boolean,
			default: false,
		},
	},
}
</script>
<template>
	<div class="waitLoad text-center text-danger my-2" v-show="loading" :class="relative ? 'prelative' : ''">
		<b-spinner class="align-middle"></b-spinner>
	</div>
</template>
<style lang="scss" scoped>
	.waitLoad {
		position: absolute;
		top: 0;
		left:0;
		width:100%;
		height: 100%;
		background: rgb(255,255,255,0.8);
		padding-top: 22%;
		z-index: 999;
	}
	.prelative {
		position: relative !important;
	}
</style>